<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span 
        class="chip mb-2"
        :style="'background-color: ' + color.hexacode"
        @click="select"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon 
          v-if="selected"
          :class="getTextColor"
        >mdi-check</v-icon>
      </span>
    </template>
    {{ color.name }}
  </v-tooltip>
  
</template>

<script>
  // EVENTS
  import { EventBus } from '@/main.js'
  // MIXINS
  import utils from '@/mixins/utils'

  export default {
    name: 'Color',

    mixins: [utils],

    data: () => ({
      selected: false,
    }),

    props: {
      color: Object,
    },

    computed: {
      getTextColor() {
        if (this.isBright(this.color.hexacode)) {
          return 'black-text'
        } else {
          return 'white-text'
        }
      }
    },

    methods: {
      select() {
        if (!this.selected) {
          this.$emit('changeColor', this.color)
          this.selected = !this.selected
        }
      }
    },

    mounted() {
      EventBus.$on('changeColor', newColor => {
        if (newColor.id != this.color.id) {
          this.selected = false
        } else {
          this.selected = true
        }
      })
    }
  }
</script>

<style scoped>
  .chip {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #000;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .white-text {
    color: #fff;
  }
  .black-text {
    color: #000;
  }
</style>